<div pias-layout-content>
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }
    <br>
    <div class="content">
        <div class="dsu-assessment-container container-fluid" [formGroup]="dsuassessmentForm">
             @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
             <h6 class="page-header">DSU ASSESSMENT FORM FOR NEW INTRODUCER ({{role}})</h6>
             }@else {
             <h6 class="page-header">DSU ASSESSMENT FORM FOR NEW Representative</h6>
             }
            @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
            <h6 class="page-header">Information on New Introducer ({{role}})</h6>
            }@else {
            <h6 class="page-header">Information on New Representative</h6>
            }
            <div class="row">
                <!-- Branch Name -->
                <div class="col-md-6">
                    @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                    <label class="field-label">Name of New Introducer {{role}} (as in NRIC/Passport)</label>
                    }@else {
                    <label class="field-label">Name of New Representative (as in NRIC/Passport)</label>
                    }
                    <mat-form-field class="w-100">
                        <input matInput formControlName="name" placeholder="Enter Name" readonly />
                    </mat-form-field>
                </div>
                <!-- Financial Services Director -->
                <div class="col-md-6">
                    <label class="field-label">
                        <!-- <mat-icon class="label-icon">star</mat-icon> -->
                        Recruiting Manager
                    </label>

                    <mat-form-field class="w-100">
                        <input matInput formControlName="manager" placeholder="Enter Recruiting Manager" readonly />
                    </mat-form-field>
                </div>
                @if(!['Introducer - Individual','Introducer - Corporate'].includes(designation) ){
                <div class="row">
                    <div class="col-12">
                        <h5 class="field-title">DSU Initial Assessment Remarks</h5>
                    </div>
                    <mat-label class="field-label"></mat-label>
                    <mat-form-field class="text-field">

                        <textarea matInput formControlName="initialremarks" placeholder="Enter text"></textarea>
                    </mat-form-field>
                </div>
                }

                @if(['Candidate Submission','Manager Review','Onboarding Processing','Rectification','Candidate Update (Assessment)','Candidate Update (Due Diligence)','DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(this.status)){
                @if(!['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                @if(['DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(this.status)){    
                <div class="col-md-6">
                    <label class="field-label">Corporate MailAddress</label>

                    <mat-form-field class="w-100">
                        <input matInput formControlName="corporateMailAddress"
                            placeholder="Enter Corporate MailAddress" />
                        @if(this.dsuassessmentForm.controls["corporateMailAddress"].invalid
                        && (this.dsuassessmentForm.controls["corporateMailAddress"].touched ||
                        this.dsuassessmentForm.controls["corporateMailAddress"].dirty)
                        ) {
                        <mat-error>
                            @if(this.dsuassessmentForm.controls["corporateMailAddress"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }@else if(this.dsuassessmentForm.controls["corporateMailAddress"].errors?.["email"])
                            {
                            <span>Invalid Corporate EmailAddress.</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
                }
                }
                @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){
                <div class="row">
                    <div class="col-12">
                        <h5 class="field-title">DSU Final Assessment Remarks</h5>
                    </div>
                    <mat-label class="field-label"></mat-label>
                    <mat-form-field class="text-field">

                        <textarea matInput formControlName="finalremarks" placeholder="Enter text"></textarea>
                    </mat-form-field>
                </div>
                }@else if (['DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(this.status)) {
                  <div class="row">
                    <div class="col-12">
                        <h5 class="field-title">DSU Final Assessment Remarks</h5>
                    </div>
                    <mat-label class="field-label"></mat-label>
                    <mat-form-field class="text-field">

                        <textarea matInput formControlName="finalremarks" placeholder="Enter text"></textarea>
                    </mat-form-field>
                </div>
                }
                }
            </div>

            @if(!['Introducer - Individual','Introducer - Corporate'].includes(designation) ){
            <h5 class="field-title">DSU Initial Assessment Acknowledgement</h5>
            <div class="dsu-container container-fluid">
                <div class="row align-items-start">
                    <mat-checkbox formControlName="initialdeclarationaccepted" (change)="changevalue('initialdeclarationaccepted')">I confirm that all required verification
                        checks have
                        been completed and supporting documents have been reviewed.</mat-checkbox>
                    @if(this.dsuassessmentForm.controls["initialdeclarationaccepted"].invalid
                    && (this.dsuassessmentForm.controls["initialdeclarationaccepted"].touched ||
                    this.dsuassessmentForm.controls["initialdeclarationaccepted"].dirty)
                    ) {
                    <mat-error>
                        @if(this.dsuassessmentForm.controls["initialdeclarationaccepted"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Name of DSU
                        </label>

                        <mat-form-field class="w-100">
                            <input matInput formControlName="initialdsuname" placeholder="Enter DSU " readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Date
                        </label>

                        <mat-form-field class="w-100">
                            <input type="date" matInput formControlName="initialdate" readonly />
                        </mat-form-field>
                    </div>
                </div>
                @if(this.errormessage1 != ''){
                <mat-error>

                    <span>{{errormessage1}}</span>
                </mat-error>
                }
            </div>
            }
            @if(['Candidate Submission','Manager Review','Onboarding Processing','Rectification','Candidate Update (Assessment)','Candidate Update (Due Diligence)','DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(this.status)){
            @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)){    
            <h5 class="field-title">DSU Final Assessment Acknowledgement</h5>
            <div class="dsu-container container-fluid">
                <div class="row align-items-start">
                    <mat-checkbox formControlName="finaldeclarationaccepted" (change)="changevalue('finaldeclarationaccepted')">I confirm that all required verification
                        checks
                        have
                        been completed and supporting documents have been reviewed.</mat-checkbox>
                    @if(this.dsuassessmentForm.controls["finaldeclarationaccepted"].invalid
                    && (this.dsuassessmentForm.controls["finaldeclarationaccepted"].touched ||
                    this.dsuassessmentForm.controls["finaldeclarationaccepted"].dirty)
                    ) {
                    <mat-error>
                        @if(this.dsuassessmentForm.controls["finaldeclarationaccepted"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Name of DSU
                        </label>

                        <mat-form-field class="w-100">
                            <input matInput formControlName="finaldsuname" placeholder="Enter DSU " readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Date
                        </label>

                        <mat-form-field class="w-100">
                            <input type="date" matInput formControlName="finaldate" readonly />
                        </mat-form-field>
                    </div>
                </div>
                @if(this.errormessage2 != ''){
                <mat-error>

                    <span>{{errormessage2}}</span>
                </mat-error>
                }
            </div>
            }@else if (['DSU Final Assessment','DSU Manager Approval','Onboarding Completed'].includes(this.status)) {
             <h5 class="field-title">DSU Final Assessment Acknowledgement</h5>
            <div class="dsu-container container-fluid">
                <div class="row align-items-start">
                    <mat-checkbox formControlName="finaldeclarationaccepted" (change)="changevalue('finaldeclarationaccepted')">I confirm that all required verification
                        checks
                        have
                        been completed and supporting documents have been reviewed.</mat-checkbox>
                    @if(this.dsuassessmentForm.controls["finaldeclarationaccepted"].invalid
                    && (this.dsuassessmentForm.controls["finaldeclarationaccepted"].touched ||
                    this.dsuassessmentForm.controls["finaldeclarationaccepted"].dirty)
                    ) {
                    <mat-error>
                        @if(this.dsuassessmentForm.controls["finaldeclarationaccepted"].errors?.["required"]) {
                        <span>{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Name of DSU
                        </label>

                        <mat-form-field class="w-100">
                            <input matInput formControlName="finaldsuname" placeholder="Enter DSU " readonly />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <label class="field-label">
                            <!-- <mat-icon class="label-icon">star</mat-icon> -->
                            Date
                        </label>

                        <mat-form-field class="w-100">
                            <input type="date" matInput formControlName="finaldate" readonly />
                        </mat-form-field>
                    </div>
                </div>
                @if(this.errormessage2 != ''){
                <mat-error>

                    <span>{{errormessage2}}</span>
                </mat-error>
                }
            </div>   
            }    
            }
            <!-- Other Attachments -->
            <div class="section-card other-attachments-card">
                <div class="section-header">
                    <mat-icon>attach_file</mat-icon>
                    <span>Other Attachments</span>
                </div>
                <div class="container-fluid">
                    <div class="row g-3">
                        @for(key of otherAttachmentKeys; track key){
                        <div class="col-md-6">
                            <div class="upload-container">
                                <div class="upload-box">
                                    <input type="file" [disabled]="isReadOnly()" [id]="key + 'fileName'"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        (change)="onOtherAttachmentFileChange($event, key)">
                                    <input type="text" [formControlName]="key + 'fileName'" hidden>

                                    <!-- Show filename OR placeholder -->
                                    @if(!this.dsuassessmentForm.get(key + 'fileName')?.value){
                                    <span>
                                        Choose file
                                    </span>
                                    }
                                    @if(this.dsuassessmentForm.get(key + 'fileName')?.value){
                                    <div class="attachment-row">
                                        <span class="file-name">
                                            {{ this.dsuassessmentForm.get(key + 'fileName')?.value }}
                                        </span>
                                        @if(isReadOnly() === false){
                                        <button type="button" class="icon-btn delete-btn"
                                            (click)="removeOtherAttachmentFile(key)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        }
                                        <button type="button" class="icon-btn delete-btn"
                                            (click)="previewAttachment(key, key + 'fileName')">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                    }
                                </div>
                                @if(isReadOnly() === false){
                                @if(!$first){
                                @if(!this.dsuassessmentForm.get(key + 'fileName')?.value){   
                                <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                                    matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                                    <mat-icon>close</mat-icon>
                                </button>
                                }
                                }
                                @if($last){
                                <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                                    matTooltip="Add another attachment" (click)="addOtherAttachment()">
                                    <mat-icon>add</mat-icon>
                                </button>
                                }
                                }
                            </div>
                            @if(this.dsuassessmentForm.get(key + 'fileName')?.invalid
                            && (this.dsuassessmentForm.get(key + 'fileName')?.touched ||
                            this.dsuassessmentForm.get(key + 'fileName')?.dirty)
                            ) {
                            <mat-error>
                                @if(this.dsuassessmentForm.get(key + 'fileName')?.errors?.['invalidType']){
                                <span>Only PDF, JPG, PNG files are allowed.</span>
                                }
                                @else if(this.dsuassessmentForm.get(key + 'fileName')?.errors?.['maxSize']){
                                <span>File size must be less than or equal to 5MB.</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>

            @if(isReadOnly() == false){
            <div class="form-actions mt-4">
                @if(['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation) || this.status === 'DSU Initial Assessment'){
                <button class="save-btn" (click)="returnByRole()">
                    <mat-icon>arrow_backward</mat-icon>
                    <span>Return to Candidate update</span>
                </button>
                }
                <button class="save-btn" type="button" (click)="saveAndContinue()">
                    <span>Save</span>
                </button>
                <button class="save-btn" type="button" [disabled]="dsuassessmentForm.invalid"
                    (click)="openConfirmDialog()">
                    <span>Submit</span>
                </button>
            </div>
            }
        </div>
    </div>
    @if (showPreview) {
    <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
        <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

            <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
                <div class="d-flex flex-column">
                    <span class="fw-bold fs-5">Document Preview</span>
                    <small class="text-muted">{{ currentFileName }}</small>
                </div>
                <div class="preview-header-actions">
                    @if (!isPdf) {
                    <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
                        <mat-icon>zoom_out</mat-icon>
                    </button>
                    <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
                    <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
                        <mat-icon>zoom_in</mat-icon>
                    </button>
                    }
                    <button mat-icon-button color="warn" (click)="closePreview()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Preview Content -->
            <div class="preview-content">
                @if (isPdf) {
                <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
                <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

                } @else {
                <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
                    [style.transform]="'scale(' + zoomLevel + ')'" />
                }
            </div>

        </div>
    </div>
    }
</div>